import MovieTimesPeriodeDaysItemAttributes from './MovieTimesPeriodeDaysItemAttributes';
import getBackgroundcolor from '../func/getBackgroundcolor';
import getShowtime from '../func/getShowtime';
import getCaptions from '../func/getCaptions';

const MovieTimesPeriodeDaysItems = ({performances, hideTheatres, hasFlyerCaptions, generalSettings, chosen_font, attributesColors, captionAttributes, accentColorDark, accentColor, cinemaData, themeColors, iconsColor, reducedVersion}) => {
    return performances.map((performance, index) => {
        let style 
        let styleThird
        let styleFourth
        let styleFifth
        let styleSixth
        let borderStyle
        let compesoUrl
        const { timeUtc, theatreName, deeplinkURL, attributes } = performance
         const shopData = cinemaData && cinemaData.scope ? cinemaData.scope.cinemaDataProvider : null
        const attributeCaptions = getCaptions(attributes, captionAttributes)

        if(hasFlyerCaptions) {
            style = { 
                backgroundColor: getBackgroundcolor(accentColorDark, null, themeColors, true)
            }

            borderStyle = {
                borderColor: getBackgroundcolor(accentColorDark, null, themeColors, true)
            }
        }

        if(shopData && (shopData.type === 'compeso' || shopData.type === 'kinoheld')) {
            compesoUrl = cinemaData.website + 'vorstellung/?performance_id=' + performance.id
        }

        if(attributes && !hasFlyerCaptions) {
            attributes.map((attribute) => {
                const id = String(attribute.id)
                const settings = _.find(attributesColors, setting => {
                    return setting.id === id
                })

                if((id === '1087' || id === '2d' || id === 'digital') || !settings) {
                    return ''
                }

                if(settings.displaySetting === "border") {
                    const coloring = settings.colorSettings ? settings.colorSettings : settings.colorToUse === 1 ? accentColorDark : settings.colorToUse === 2 ? accentColor : settings.colorToUse === 3 ? accentColor : accentColorDark
                    if(settings.colorToUse === 1) {
                        styleThird = {
                            borderColor: 'transparent transparent ' +  coloring + ' transparent'
                        }
                    } else if(settings.colorToUse === 2) {
                        styleFourth = {
                            borderColor: 'transparent transparent transparent ' +  coloring,
                            filter: settings.colorSettings ? "none" : "sepia(1)"
                        }
                    }  else if(settings.colorToUse === 3) {
                        styleFifth = {
                            borderColor: 'transparent ' + coloring + ' transparent transparent',
                            filter: settings.colorSettings ? "none" :  "sepia(1) invert(1) brightness(1.5)"
                        } 
                    } else {
                        styleSixth = {
                            borderColor: coloring + ' transparent transparent transparent',
                            filter: settings.colorSettings ? "none" : "invert(1)"
                        }
                    }
                } else {
                    if(settings.colorSettings) {
                        style = {
                            backgroundColor: settings.colorSettings,    
                        }
                    } else {
                        const coloring = settings.colorToUse === 1 ? accentColorDark : settings.colorToUse === 2 ? accentColor : settings.colorToUse === 3 ? accentColor : accentColorDark
                        style = {
                            backgroundColor: coloring,
                            filter: settings.styleFilter
                        }
                    }
                }
            })
        }
        
        return hasFlyerCaptions ? (
            <a key={index} style={borderStyle} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                <span className={`${chosen_font}-text-xsmall-light showtime`}>{getShowtime(timeUtc)}</span>
                <span className={`${chosen_font}-text-xsmall-light captions`} style={style}>{attributeCaptions.map((cap, index) => {
                    return <span className='caption' key={index}>{cap}</span>
                })}</span>
            </a>
        ) : reducedVersion ? (
            <a key={index} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                {style && <div style={style} className="others-styling item-background attribute-background"></div>}
                <span className={`${chosen_font}-text-xsmall-light showtime`}>{getShowtime(timeUtc)}</span>
                {styleThird && <div style={styleThird} className="others-styling item-1 attribute-border"></div>}
                {styleFourth && <div style={styleFourth} className="others-styling item-2 attribute-border"></div>}
                {styleFifth && <div style={styleFifth} className="others-styling item-3 attribute-border"></div>}
                {styleSixth && <div style={styleSixth} className="others-styling item-4 attribute-border"></div>}
            </a>
        ) : (
            <a key={index} href={compesoUrl ? compesoUrl : deeplinkURL} target="_blank" className={"show-wrapper cursor-pointer"}>
                <span className={`${chosen_font}-text-bold-grey showtime`}>{getShowtime(timeUtc)}</span>
                <MovieTimesPeriodeDaysItemAttributes accentColorDark={accentColorDark} attributes={attributes} hideTheatres={hideTheatres} theatreName={theatreName} iconsColor={iconsColor}/>
            </a>
        )
    })
}

export default MovieTimesPeriodeDaysItems